import { render } from "./DetailOurTeam.vue?vue&type=template&id=40c6b91a"
import script from "./DetailOurTeam.vue?vue&type=script&lang=js"
export * from "./DetailOurTeam.vue?vue&type=script&lang=js"

import "./DetailOurTeam.vue?vue&type=style&index=0&id=40c6b91a&lang=css"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__